/* globals $ */

import { Collapsible } from "../collapsible";

export default class FaqsAll {
  constructor($elem) {
    this.$elem = $elem;
    new Collapsible($elem);
    $elem.find(".filters li").click((e) => {
      let id = $(e.currentTarget).data("id");
      this.$elem.find(".filters-form [name=category]").val(id);
      this.changeTab();
    });
    $elem.find(".filters-form [name=category]").change(() => {
      this.changeTab();
    });
  }

  changeTab() {
    let id = this.$elem.find(".filters-form [name=category]").val();
    this.$elem.find(".filters li.active").removeClass("active");
    this.$elem.find(".filters li[data-id=" + id + "]").addClass("active");
    this.$elem
      .find(".faq-tab.active")
      .removeClass("active")
      .fadeOut("fast", () => {
        this.$elem
          .find(".faq-tab[data-id=" + id + "]")
          .addClass("active")
          .fadeIn("fast");
      });
  }
}
